angular.module('jv.Dashboard.Billboard.Controller', [])
.controller('jv.Dashboard.Billboard.Controller', ['$scope', 'jvDashboardAjaxService', 'jvContextualLoadingService','$rootScope',
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $rootScope) {
    
    $scope.refreshTimestamp = true;
    //Handler for refresh_widget
    $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
        if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
            $scope.refreshTimestamp = false;
            fetchBillboardContent();
        }
    });

    var widgetObject = $scope.widgetObject;
    $scope.noBillboard = false;

    var fetchBillboardContent = function(){
        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        jvDashboardAjaxService.getBillboardContent({}, function(response) {
            jvContextualLoadingService.hide($scope.widgetObject.widgetId);
            $scope.refreshTimestamp = true;
            if (response.billboard) {
                $scope.title = response.billboard.title;
                $scope.content = response.billboard.content;
            } else {
                $scope.noBillboard = true;
            }
        });
    };
    fetchBillboardContent();
}]);
